<script setup>
import AppSwiper from '#/general/AppSwiper'
import { inject, onMounted, ref } from 'vue'

const { screen } = inject('Shared')

const testimonials = [
  {
    img: require('assets/img/home/adrian-testimonial.png'),
    name: 'Adrian Rüegger-Strübin',
    job: 'Eigentümer / Raumpionier',
    comment: '«Dass wir auf unserem Grundstück noch riesiges Potenzial haben, war uns klar. Doch erst als die RAUMPIONIERE ins Spiel kamen und uns das mit Ihrer Expertise bestätigten, haben wir beschlossen als Familie den Schritt in die Umsetzung zu wagen. Die RAUMPIONIERE sind sympathisch, kompetent und engagiert – wir können sie nur empfehlen!»'
  },
  {
    img: require('assets/img/home/Tanner.png'),
    name: 'Familie Tanner',
    job: 'Eigentümer / Raumpioniere',
    comment: '«Die Raumpioniere haben uns buchstäblich an der Hand genommen, nachdem wir dank ihrem Potenzialrechner herausgefunden haben, dass wir auf unserem Grundstück noch viel Potenzial haben. Heute sind wir dabei, unsere alte Liegenschaft durch ein Mehrfamilienhaus zu ersetzen – das Projekt starten wir gerade zusammen mit den Raumpionieren!»'
  }
]

const size = ref('100%')
const swiper = ref()
onMounted(() => {
  let res
  if (screen.width > 1250) {
    res = window.innerWidth - ((window.innerWidth - 1200) / 2)
  }
  size.value = res + 'px'
})
</script>

<template lang="pug">
.b2c--testimonials-container
  .b2c--swiper-container
    app-swiper.b2c--testimonials-swiper(:items="testimonials" :slides-per-view="1" :loop="true" :autoplay="{ delay: 5000 }" @swiper="swiper = $event" :initial-slide="0")
      template(#item="props")
        .routerPageSize
          .b2c-testimonial--container
            img.b2c-testimonial--img(:src="props.item.img")
            .b2c-testimonial--content
              .b2c-testimonial--title Feedback
              .b2c-testimonial--name {{ props.item.name }}
              .b2c-testimonial--job {{ props.item.job }}
              .b2c-testimonial--comment {{ props.item.comment }}
    .b2c--swiper-navigation
      .b2c--swiper-navigation-item(v-for="(testimonial, index) in testimonials" :key="index" :class="index === (swiper ? swiper.realIndex : 0) ? 'b2c--swiper-navigation-item-active' : ''" @click="swiper.slideTo(index + 1)")
</template>

<style lang="sass">
.b2c--testimonials-container
  background: #F6F7FA
  @media screen and (max-width: 1024px)
    .routerPageSize
      padding: 0px !important
  .swiper-slide-next
    opacity: 0.5 !important
    transition: opacity 0.3s ease-in-out
    .b2c-testimonial--content
      opacity: 0 !important
      transition: opacity 0.3s ease-in-out
  .b2c--swiper-container
    position: relative
    width: 100%
    @media screen and (min-width: 1024px)
      padding: 80px 0
    @media screen and (max-width: 1024px)
      padding: 40px 0 67px
    .b2c--swiper-navigation
      position: absolute
      display: flex
      align-content: center
      @media screen and (min-width: 1024px)
        left: 50%
        bottom: 20px
      @media screen and (max-width: 1024px)
        left: 0px
        justify-content: center
        width: 100%
        bottom: 29px
      .b2c--swiper-navigation-item-active
        background: #1F47CD !important
      .b2c--swiper-navigation-item
        cursor: pointer
        margin-right: 10px
        width: 8px
        height: 8px
        background: #DCE7F2
        border-radius: 100%
        transition: background-color 0.5s ease-in-out
    .b2c--testimonials-swiper
      .b2c-testimonial--container
        display: flex
        @media screen and (min-width: 1024px)
          flex-direction: row
          width: 100%
        @media screen and (max-width: 1024px)
          width: calc(100% - 30px)
          flex-direction: column
          padding-left: 30px
        .b2c-testimonial--img
          border-radius: 100%
          @media screen and (min-width: 1024px)
            width: 300px
            min-width: 300px
            max-width: 300px
            height: 300px
            min-height: 300px
            max-height: 300px
          @media screen and (max-width: 1024px)
            width: 150px
            min-width: 150px
            max-width: 150px
            height: 150px
            min-height: 150px
            max-height: 150px
        .b2c-testimonial--content
          @media screen and (min-width: 1024px)
            margin-left: 96px
          @media screen and (max-width: 1024px)
            max-width: 90%
          .b2c-testimonial--title
            line-height: 130%
            color: #1F47CD
            font-weight: 700
            @media screen and (min-width: 1024px)
              font-size: 20px
              margin-bottom: 3px
            @media screen and (max-width: 1024px)
              margin-top: 30px
              font-size: 16px
              margin-bottom: 18px
          .b2c-testimonial--name
            color: #2B3342
            font-weight: 500
            line-height: 125%
            @media screen and (min-width: 1024px)
              font-size: 34px
            @media screen and (max-width: 1024px)
              font-size: 24px
          .b2c-testimonial--job
            color: #2B3342
            font-weight: 400
            font-size: 20px
            line-height: 125%
          .b2c-testimonial--comment
            line-height: 150%
            color: #2C3443
            @media screen and (min-width: 1024px)
              margin-top: 40px
              font-size: 20px
            @media screen and (max-width: 1024px)
              margin-top: 18px
              font-size: 16px
</style>
